import { render, staticRenderFns } from "./ruzhu.vue?vue&type=template&id=e3214e6e"
import script from "./ruzhu.vue?vue&type=script&lang=js"
export * from "./ruzhu.vue?vue&type=script&lang=js"
import style0 from "./ruzhu.vue?vue&type=style&index=0&id=e3214e6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports